/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The reason of smart meter eligibility
 */
export type SmartMeterEligibilityReasonEnum =
  (typeof SmartMeterEligibilityReasonEnum)[keyof typeof SmartMeterEligibilityReasonEnum]

export const SmartMeterEligibilityReasonEnum = {
  ELIGIBLE_DUAL_EXCHANGE: "ELIGIBLE_DUAL_EXCHANGE",
  ELIGIBLE_GAS_EXCHANGE: "ELIGIBLE_GAS_EXCHANGE",
  ELIGIBLE_ELEC_EXCHANGE: "ELIGIBLE_ELEC_EXCHANGE",
  INELIGIBLE_SWITCHING_AWAY: "INELIGIBLE_SWITCHING_AWAY",
  INELIGIBLE_ALREADY_SMART: "INELIGIBLE_ALREADY_SMART",
  INELIGIBLE_TOO_COMPLEX: "INELIGIBLE_TOO_COMPLEX",
  UNRECOGNIZED: "UNRECOGNIZED",
  INELIGIBLE_MOP_DISCREPANCY: "INELIGIBLE_MOP_DISCREPANCY",
} as const
